import * as React from 'react';
import cx from 'classnames';
import { Flex } from '@common/components/Flex';
import { I18n } from 'react-redux-i18n';
import { Button } from '@common/components/Button';
import { getTestAttributes } from '@common/utils/tests';
import { MODULE_NAME } from '@modules/fhq-design-tool/constants/shared';
import { Loading } from '@common/components/loading';

import './actions.styles.scss';

export type ActionsProps = {
  disabledState: {
    save: boolean;
    newQuestionnaire: boolean;
    deleteQuestionnaire: boolean;
    copyQuestionnaire: boolean;
    export: boolean;
    import: boolean;
  };
  className?: string;
  onQuestionnaireCreate: () => Promise<void>;
  onQuestionnaireDelete: () => Promise<void>;
  onQuestionnaireSave: () => Promise<void>;
  onQuestionnaireCopy: () => Promise<void>;
  onQuestionnaireImport: () => void;
  onQuestionnaireExport: () => Promise<void>;

};

export const Actions: React.FC<ActionsProps> = (props) => {
  const { className, onQuestionnaireDelete, onQuestionnaireCreate, disabledState, onQuestionnaireSave, onQuestionnaireCopy, onQuestionnaireImport, onQuestionnaireExport } = props;
  const [loadingBtnIndex, setLoadingBtnIndex] = React.useState<number | undefined>(undefined);

  const handleAction = React.useCallback((fn: () => Promise<void> | void, index: number) => async () => {
    setLoadingBtnIndex(index);
    await fn();
    setLoadingBtnIndex(undefined);
  }, []);

  const actions = [
    {
      iconSrc: 'gif/save.gif',
      label: 'Save',
      disabled: disabledState.save,
      onClick: onQuestionnaireSave,
    },
    {
      iconSrc: 'gif/questionnaire_add.gif',
      label: 'New Questionnaire',
      disabled: disabledState.newQuestionnaire,
      onClick: onQuestionnaireCreate,
    },
    {
      iconSrc: 'gif/questionnaire_delete.gif',
      label: 'Delete Questionnaire',
      disabled: disabledState.deleteQuestionnaire,
      onClick: onQuestionnaireDelete,
    },
    {
      iconSrc: 'gif/questionnaire_copy.gif',
      label: 'Copy Questionnaire',
      disabled: disabledState.copyQuestionnaire,
      onClick: onQuestionnaireCopy,
    },
    {
      iconSrc: 'gif/ss_export.gif',
      label: 'Export',
      disabled: disabledState.export,
      onClick: onQuestionnaireExport,
    },
    {
      iconSrc: 'gif/ss_import.gif',
      label: 'Import',
      disabled: disabledState.import,
      onClick: onQuestionnaireImport,
    },
  ].map(({ label, onClick, ...restData }, index) => ({ 
    ...restData, 
    label: I18n.t(label),
    onClick: onClick ? handleAction(onClick, index) : undefined,
  }));

  return (
    <Flex 
      className={cx(
        'FhqDesignToolActions', 
        { 
          'FhqDesignToolActions--disabled': loadingBtnIndex !== undefined,
        }, 
        className
      )} 
      alignItems="center">
      {actions.map(({ iconSrc, label, ...btnProps }, index) => (
        <Button
          key={label}
          className="FhqDesignToolActions__btn"
          {...getTestAttributes(MODULE_NAME, 'action', 'button', label.toLowerCase().replace(' ', '-'))}
          {...btnProps}
        >
          {loadingBtnIndex !== index 
            ? <img src={iconSrc} />
            : <Loading size={16} />}
          {I18n.t(label)}
        </Button>
      ))}
    </Flex>
  );
};